import { effect, inject, Injectable, untracked } from '@angular/core';
import { MyTripFacade } from '@com-delta-idp/mnx-capability-trip-management-smart';
import { MyTripAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { filter, take } from 'rxjs/operators';
import { LoginFacadeService } from '../../../../data-access/facades/login/login-facade.service';
import { NavigationType } from '../../../../data-access/models';
import { HeaderStateService } from './header-state.service';
import { ScreenDetectionService } from './screen-detection.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private headerState = inject(HeaderStateService);
  private screenDetection = inject(ScreenDetectionService);
  private myTripFacade = inject(MyTripFacade);
  private loginFacade = inject(LoginFacadeService);
  constructor() {
    effect(() => {
      const showMyTrip = this.myTripFacade.showMytrip();
      if (showMyTrip) {
        untracked(() => {
          this.headerState.selectedNav.set(NavigationType.myTrips);
          if (this.screenDetection.isMobile()) {
            this.headerState.mobileWidgetNavClick.set(true);
            this.headerState.displayCloseIcon.set(true);
          }
          this.headerState.previousPrimarySelectedNav = NavigationType.myTrips;
        });
      }
    });
  }

  showMyTrips(content: MyTripAem | undefined): void {
    this.loginFacade.isLoggedIn$
      .pipe(
        filter((isLoggedIn) => isLoggedIn && !!content),
        take(1)
      )
      .subscribe(() => {
        this.myTripFacade.init(content, true);
      });
  }

  hideSecondaryDesktopNav(): void {
    if (this.headerState.selectedNav() && this.screenDetection.isMobile()) {
      this.headerState.selectedNav.set(NavigationType.book);
    }
  }
}
